export type AttributeGroup = {
  id: number;
  attributeGroupNameen: string;
  attributeGroupNamede: string;
};

export type Column = {
  mbdAttributeGroup?: AttributeGroup | null;
  attrInternalName?: string;
  attrDisplayNameen?: string;
  attrDisplayNamede?: string;
  headerName?: string;
  label?: string;
  [key: string]: any;
};

export type GroupedNode = {
  id: string;
  label: string;
  children?: Column[];
  groupSize?: number;
  isGrouped?: boolean;
};

export function groupByAttributeGroup(
  allAccessibleColumns: Column[],
  language: 'en' | 'de' = 'en',
): GroupedNode[] {
  const groupsMap: Record<string | number, GroupedNode> = {};
  const result: GroupedNode[] = [];

  allAccessibleColumns.forEach((item) => {
    const group = item.mbdAttributeGroup;

    if (group && group.id != null) {
      const label = language === 'de' ? group.attributeGroupNamede : group.attributeGroupNameen;

      if (!groupsMap[group.id]) {
        groupsMap[group.id] = {
          id: group.id.toString(),
          label,
          children: [],
        };
        result.push(groupsMap[group.id]);
      }
      groupsMap[group.id].children!.push(item);
    } else {
      const key = item.attrInternalName || item.label || `ungrouped-${result.length}`;
      const label =
        (language === 'de' ? item.attrDisplayNamede : item.attrDisplayNameen) || item.label || '';
      if (!groupsMap[key]) {
        groupsMap[key] = {
          id: key,
          label: label,
          children: [],
        };
        result.push(groupsMap[key]);
      }
      groupsMap[key].children!.push(item);
    }
  });

  return result.map((group) => ({
    ...group,
    groupSize: group.children?.length || 0,
    isGrouped: (group.children?.length || 0) > 1,
  }));
}
